export default "__VITE_ASSET__COumLU0M__"